import { Component } from '@angular/core';
import { GenericCrudComponent } from '../../../shared/components/generic-crud/generic-crud.component';
import { GenericForm, GenericFormField } from '../../../models/GenericCRUD/GenericForm';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../models/GenericCRUD/GenericTable';
import { Filter } from '../../../models/GenericCRUD/Filter';
import { GenericCRUD } from '../../../models/GenericCRUD/GenericCRUD';
import { Paginator } from '../../../models/Paginator';
import { Proof } from '../../../models/Proof';
import { RouterOutlet } from '@angular/router';
import { BreadcrumbService } from '../../../core/services/breadcrumb/breadcrumb.service';


@Component({
  selector: 'app-proofs',
  standalone: true,
  imports: [GenericCrudComponent, RouterOutlet],
  templateUrl: './proofs.component.html',
  styleUrls: ['./proofs.component.css']
})
export class ProofsComponent {

}